import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFeedbackFormActionType } from './types';

export const disableLoadForm = actionGenerator(EFeedbackFormActionType.LoadFormDisabled);
